import {MESSAGE} from './message'
import {ERROR_CODE, MENU_TYPE, PERMISSION_KEY, PERMISSION_VALUE} from './constant'
import store from '../vuex/store'
import moment from 'moment'

export default {
  isSuperUser (userInfo) {
    return userInfo.is_superuser
  },
  isAdminUser (userInfo) {
    return !userInfo.is_superuser &&
      userInfo.roles.length === 1 &&
      userInfo.roles[0].department == null &&
      userInfo.roles[0].role == null
  },
  showMenuItem (item) {
    if (this.isSuperUser(store.getters.currentUser.user_info)) {
      return item.menuType === MENU_TYPE.ALL || item.menuType === MENU_TYPE.NORMAL || item.menuType === MENU_TYPE.SUPER_ADMIN || item.menuType === MENU_TYPE.ADMIN
    }
    if (this.isAdminUser(store.getters.currentUser.user_info)) {
      return item.menuType === MENU_TYPE.ALL || item.menuType === MENU_TYPE.NORMAL || item.menuType === MENU_TYPE.ADMIN
    }
    return item.menuType === MENU_TYPE.ALL || item.menuType === MENU_TYPE.NORMAL
  },
  getCompanyByUserInfo (userInfo) {
    if (userInfo && userInfo.roles && userInfo.roles.length > 0) {
      return userInfo.roles[0].company
    }
    return null
  },
  isTechnicalStaff (userInfo) {
    const found = userInfo.roles.find(item => item.department && item.department.department_name === 'Phòng Kỹ Thuật')
    return found !== undefined
  },
  /**
   * Phone number check
   * @param phoneNumber
   */
  phoneNumberCheck (phoneNumber) {
    var vnf_regex = /(([0-9]|\+84)+([0-9]{7,})\b)/g
    return vnf_regex.test(phoneNumber)
  },
  /**
   * show success toast
   */
  successToast (toast, title = MESSAGE.SUCCESS, content = MESSAGE.SUCCESS_MESSAGE) {
    toast.toast(content, {
      title: title,
      variant: 'success',
      solid: true,
      autoHideDelay: 3000
    })
  },
  /**
   * Show fail toast
   */
  failedToast (toast, title = MESSAGE.SERVER_ERROR, content = MESSAGE.SERVER_ERROR_MESSAGE) {
    toast.toast(content, {
      title: title,
      variant: 'danger',
      solid: true,
      autoHideDelay: 3000
    })
  },
  warnToast (toast, title = MESSAGE.SUCCESS, content = MESSAGE.SUCCESS_MESSAGE) {
    toast.toast(content, {
      title: title,
      variant: 'warn',
      solid: true,
      autoHideDelay: 3000
    })
  },
  translatePermissionKey (permissions) {
    return permissions.map(item => {
      if (item === PERMISSION_KEY.MARKETING) {
        return PERMISSION_VALUE.MARKETING
      }
      if (item === PERMISSION_KEY.DATA_MANAGEMENT) {
        return PERMISSION_VALUE.DATA_MANAGEMENT
      }
      if (item === PERMISSION_KEY.USER_MANAGEMENT) {
        return PERMISSION_VALUE.USER_MANAGEMENT
      }
      if (item === PERMISSION_KEY.PRODUCT_AND_WAREHOUSE) {
        return PERMISSION_VALUE.PRODUCT_AND_WAREHOUSE
      }
      if (item === PERMISSION_KEY.ACCOUNTING) {
        return PERMISSION_VALUE.ACCOUNTING
      }
      if (item === PERMISSION_KEY.SYSTEM_CONFIGURATION) {
        return PERMISSION_VALUE.SYSTEM_CONFIGURATION
      }
      if (item === PERMISSION_KEY.REPORT) {
        return PERMISSION_VALUE.REPORT
      }
      return item
    })
  },
  handleError (toast, err) {
    if (err.response.status === 400 || err.response.status === 401 || err.response.status === 403) {
      this.errorMsg = ERROR_CODE[err.response.data.code]
      this.failedToast(toast, MESSAGE.SERVER_ERROR, ERROR_CODE[err.response.data.code])
    }
    if (err.response.status === 500) {
      this.failedToast(toast, MESSAGE.SERVER_ERROR, MESSAGE.SERVER_ERROR)
    }
  },
  formatPhoneNumber (phoneNumber) {
    if (phoneNumber.startsWith('+84')) {
      return phoneNumber.replace('+84', '0')
    }
    if (phoneNumber.startsWith('840')) {
      return '0'.concat(phoneNumber.substr(3))
    }
    if (phoneNumber.startsWith('84')) {
      return phoneNumber.replace('84', '0')
    }
    return phoneNumber
  },
  convertSecondToMMSS (second) {
    return moment.utc(second * 1000).format('HH:mm:ss')
  },
  toNumberStr (n) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(n)
  },
  convertViToEn (str, toUpperCase = false) {
    str = str.toLowerCase()
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
    str = str.replace(/đ/g, 'd')
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '')
    str = str.replace(/\u02C6|\u0306|\u031B/g, '')

    return toUpperCase ? str.toUpperCase() : str
  }
}



// WEBPACK FOOTER //
// ./src/common/utils.js